import { useWalletStore } from "../../stores/walletStore";

export async function withWalletBalanceMutationLock<T>(
    reason: string,
    work: () => Promise<T>
): Promise<{ acquired: boolean; result: T | null }> {
    const lockId = useWalletStore.getState().beginBalanceMutation(reason);
    if (lockId === null) {
        return { acquired: false, result: null };
    }

    try {
        return {
            acquired: true,
            result: await work()
        };
    } finally {
        useWalletStore.getState().endBalanceMutation(lockId);
    }
}
